import { HomeRemoveIcon } from './HomeRemoveIcon';

/**
 * author: Michael Irigoyen
 * id FEF8AC85-F9E6-4C9B-B0C2-A5158AAD8A8B
 * name home-remove
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-remove.svg
 * tags
 * - Home Automation 
 */
export const HouseRemoveIcon = HomeRemoveIcon;
export default HouseRemoveIcon